import * as React from "react"
import { Hidden, Visible } from "react-grid-system"
import { isEvenNumber } from "../../utils/helpers"
import Card from "../atoms/Card"
import TerminalsOverviewActionBar from "../molecules/Terminals/TerminalsOverviewActionBar"
import TerminalOverviewMobileview from "../molecules/Terminals/TerminalsOverviewMobileView"
import TerminalOverviewTerminalBar from "../molecules/Terminals/TerminalsOverviewTerminalBar"
import { TerminalDataModel } from "../../utils/models"

interface Props {
  terminals: Array<TerminalDataModel>
  onSortTerminalName?: () => void
  onSortSerialNumber?: () => void
  onSortSuborg?: () => void
  onSortDataUsage?: () => void
  checkCardOpen: (id: number) => boolean
  onClickCard: (id: number) => void
  onSortGroup?: () => void
  onSortStatus?: () => void
  onSelect?: (id: string | number, selected: boolean) => void
  isSelected?: (id: string | number) => boolean
  selectMode: boolean
  onCloseCard: (id: number) => void
}

const TerminalsOverviewCard: React.FunctionComponent<Props> = ({
  terminals,
  onSortDataUsage,
  onSortSerialNumber,
  onSortSuborg,
  onSortTerminalName,
  checkCardOpen,
  onClickCard,
  onSortGroup,
  onSortStatus,
  onSelect,
  isSelected,
  selectMode,
  onCloseCard,
}) => {
  return (
    <Card noPadding>
      <Hidden xs>
        <TerminalsOverviewActionBar
          onSortTerminalName={onSortTerminalName}
          onSortSerialNumber={onSortSerialNumber}
          onSortSuborg={onSortSuborg}
          onSortDataUsage={onSortDataUsage}
          onSortGroup={onSortGroup}
          onSortStatus={onSortStatus}
        />
      </Hidden>
      <div style={{ overflow: "clip" }}>
        {terminals?.map((terminal: TerminalDataModel, index: number) => (
          <div key={terminal.id}>
            <Hidden xs>
              <TerminalOverviewTerminalBar
                terminal={terminal}
                useGreyBackground={!isEvenNumber(index)}
                cardOpen={checkCardOpen(parseFloat(terminal.id.toString()))}
                onClickTerminalDetails={() => onClickCard(parseFloat(terminal.id.toString()))}
                onCloseCard={() => onCloseCard(parseFloat(terminal.id.toString()))}
                selectMode={selectMode}
                onSelectForExport={() => onSelect?.(terminal.id, !isSelected?.(terminal.id) ?? false)}
                selectedForExport={isSelected?.(terminal.id)}
              />
            </Hidden>
            <Visible xs>
              <TerminalOverviewMobileview
                terminal={terminal}
                useGreyBackground={!isEvenNumber(index)}
                cardOpen={checkCardOpen(parseFloat(terminal.id.toString()))}
                onClickTerminalDetails={() => onClickCard(parseFloat(terminal.id.toString()))}
              />
            </Visible>
          </div>
        ))}
      </div>
    </Card>
  )
}

export default TerminalsOverviewCard
